module.exports = __webpack_public_path__ + "img/aura-mapview.71aad27a.png";